// src/utils/configRestricciones.js

/**
 * Configuración centralizada para la restricción de menús
 * Aquí se agregan los brokers por código y los elementos visuales 
 * (en este caso el título del cotizador) que se desean ocultar.
 */
export const brokersRestringidos = [
    {
        brokerCodigo: "2-88",
        menusOcultos: ["VEHÍCULOS"]
    }
];

/**
 * Función utilitaria para procesar el listado de cotizadores 
 * y retornar la lista validada ocultando los menús que correspondan.
 * 
 * @param {Array} cotizadores - La lista original de cotizadores.
 * @param {string} brokerCodigo - El código del broker del usuario logueado.
 * @returns {Array} - La lista filtrada de cotizadores permitidos.
 */
export const filtrarCotizadoresPorBroker = (cotizadores, brokerCodigo) => {
    if (!cotizadores || !Array.isArray(cotizadores) || !brokerCodigo) {
        return cotizadores;
    }

    const configuracion = brokersRestringidos.find(
        (config) => config.brokerCodigo === brokerCodigo
    );

    // Si no hay configuración restrictiva para el broker devolver lista original
    if (!configuracion) {
        return cotizadores;
    }

    // Filtrar los cotizadores cuyo título NO se encuentre en la lista de menús ocultos
    return cotizadores.filter((cotizador) => {
        // Se compara usando mayúsculas para evitar problemas de case sensitiveness
        const tituloCotizador = cotizador.titulo ? cotizador.titulo.toUpperCase().trim() : "";

        return !configuracion.menusOcultos.some(
            (menuOculto) => menuOculto.toUpperCase().trim() === tituloCotizador
        );
    });
};
